module.exports = __webpack_public_path__ + "static/media/Crayon Girl.87e3bf82.jpg";